import * as arr from "./helpers/array";

const options = [
	"rename-sheet",
	"remove-sheet"
];

const actionMap = {
	"remove-sheet": function(view){
		view.confirm({
			text: webix.i18n.spreadsheet.labels["sheet-remove-confirm"]
		}).then(()=>{
			remove(view, view._activeSheet);
		});
	},
	"rename-sheet": function(view){
		edit(view, view._activeSheet);
	},
	"new-sheet": function(view){
		add(view);
	},
	"copy-sheet": function(view){
		copy(view);
	}
};

export function init(view){
	view.attachEvent("onComponentInit", () => ready(view));
}

export function defaultBottom(view){
	var readonly = view.config.readonly;
	var tabWidth = view.config.sheetTabWidth;
	var toolbar =  {
		view: "toolbar",
		id: "bottom-toolbar",
		css: "webix_ssheet_bottom_toolbar webix_layout_toolbar",
		paddingY: 0,
		height: 34,
		elements:[
			{
				view: "button", type:"htmlbutton", width: 34, id: "add-sheet",
				label: "<span class='webix_ssheet_icon_add_sheet'></span>",
				tooltip: webix.i18n.spreadsheet.tooltips["add-sheet"]||"", hidden:readonly
			},
			{
				id:"sheets",
				view:"sheets",
				width: 5 * tabWidth,
				editable:!readonly,
				editaction: "dblclick",
				editor:"text",
				editValue:"value",
				type:{
					width: tabWidth,
					height: 32,
					template: function(obj){
						return "<div>"+obj.value+"</div>"+
							(!readonly?"<div class='webix_input_icon wxi-menu-down webix_ssheet_sheet_arrow'></div>":"");
					},
					//remove skin selection css on dnd
					css:"ssheet_order_sheets"
				},
				onClick:{
					webix_ssheet_sheet_arrow: function(e, id){
						initSheetMenu(view, e, id);
					}
				},
				on:{
					onItemClick: function(id){
						if(id != view._activeSheet)
							view.showSheet(id);
					}
				}
			},
			{
				view: "button", type:"htmlbutton", width: 34, id: "prev-sheet", disabled:true, hidden:true,
				label: "<span class='webix_icon wxi-menu-left'></span>", batch:"pager",
				click:function(){scrollSheets(view, -1);}
			},
			{
				view: "button", type:"htmlbutton", width: 34, id: "next-sheet", hidden:true,
				label: "<span class='webix_icon wxi-menu-right'></span>", batch:"pager",
				click:function(){scrollSheets(view, 1);}
			}
		]
	};

	view.callEvent("onViewInit", ["bottom-toolbar", toolbar]);

	return toolbar;
}

function scrollSheets(view, direction){
	var sheets = view.$$("sheets");
	sheets.scrollTo(sheets.getScrollState().x+(direction*view.config.sheetTabWidth), 0);
}

function menuInit(view){
	var data = [];
	for(var i=0; i < options.length;i++)
		data.push({id: options[i], value:webix.i18n.spreadsheet.menus[options[i]]||options[i]});

	var menu =  {
		view: "ssheet-suggest",
		data: data
	};
	view.callEvent("onViewInit", ["sheet-menu", menu]);
	return menu;
}

export function reset(view, obj){
	let tabs = view.$$("sheets");
	if (tabs){
		tabs.clearAll();
		let set = [];
		obj.sheets.forEach(function(sheet){
			set.push({id:sheet.name, value: sheet.name});
		});
		tabs.parse(set);
	}
}

function ready(view){
	prepare(view);

	if(view.$$("add-sheet"))
		view.$$("add-sheet").attachEvent("onItemClick", function(){
			add(view);
		});

	view.attachEvent("onAfterSheetShow", (name) => selectSheet(view,name));

	view.attachEvent("onCommand", function(command){
		if(actionMap[command.id])
			actionMap[command.id](this);
	});

	if(view.$$("sheets")){
		view.$$("sheets").data.attachEvent("onStoreUpdated", () => changePagerVisability(view));
		view.$$("sheets").attachEvent("onAfterScroll", () => changePagerStatus(view));
		view.$$("sheets").attachEvent("onAfterDrop", (context) => dataOrder(view,context.start,context.index));
		view.$$("sheets").attachEvent("onAfterEditStop", (state) => rename(view,state.old,state.value));
	}
}

function initSheetMenu(view, e, id){
	if(!view.$sheetMenu){
		view.$sheetMenu = webix.ui(menuInit(view));
		view._destroy_with_me.push(view.$sheetMenu);
		view.$sheetMenu.attachEvent("onItemClick", (id)=> callAction(view,id));
	}

	if(view.$sheetMenu.getItem("remove-sheet"))
		if(view.$$("sheets").count() == 1)
			view.$sheetMenu.disableItem("remove-sheet");
		else
			view.$sheetMenu.enableItem("remove-sheet");
	if(view.callEvent("onBeforeSheetMenu", [id])){
		view.$sheetMenu.show(e);
	}
}

function changePagerStatus(view){
	const sheets = view.$$("sheets");
	const scrollPos = sheets.getScrollState().x;

	if(scrollPos == 0){
		view.$$("prev-sheet").disable();
	}
	else{
		view.$$("prev-sheet").enable();
		var tabWidth = view.config.sheetTabWidth;
		if(scrollPos == (sheets.count()-(sheets.config.width/tabWidth))*tabWidth){
			view.$$("next-sheet").disable();
			return;
		}
	}
	view.$$("next-sheet").enable();
}

function changePagerVisability(view){
	var toolbar = view.$$("bottom-toolbar");
	var sheets = view.$$("sheets");

	if(sheets.count() <= (sheets.config.width/view.config.sheetTabWidth))
		toolbar.showBatch("pager", false);
	else
		toolbar.showBatch("pager");
}

function dataOrder(view, name, num){
	for (let id in view._sheets) {
		if (view._sheets[id].name == name) {
			const item = view._sheets.splice(id, 1);
			view._sheets.splice(num, 0, item[0]);
			break;
		}
	}
}

export function add(view, content){
	var index, name, newIndex;

	index = arr.findIndex(view._sheets, x => x.name == view._activeSheet);
	newIndex = index>-1?index+1:view._sheets.length;
	name = getNewTitle(view);
	content = content || {data:[]};
	view._sheets.splice(newIndex, 0, {
		name: name,
		content: content
	});
	view.$$("sheets").add({id: name, value: name},newIndex);
	view.showSheet(name);
	view.callEvent("onSheetAdd", [name]);
	return name;
}

function getNewTitle(view){
	var index = view._sheets.length+1;
	while(getSheet(view, (webix.i18n.spreadsheet.labels.sheet+index)))
		index++;
	var name = webix.i18n.spreadsheet.labels.sheet+index;
	return name;
}

function selectSheet(view,name){
	if(view.$$("sheets")){
		view.$$("sheets").select(name);
		view.$$("sheets").showItem(name);
	}
}

export function edit(view,name){
	view.$$("sheets").edit(name);
}

export function remove(view,name){
	var index, newSheet;
	if(view._sheets.length >1){
		index = arr.findIndex(view._sheets,x => x.name == name);
		view._sheets.splice(index,1);
		if(!view._sheets[index])
			index = 0;
		newSheet = 	view._sheets[index];
		view._activeSheet = null;
		if(view.$$("sheets")){
			view.$$("sheets").remove(name);
			view.$$("sheets").refresh();
		}
		view.showSheet(newSheet.name);
		view.callEvent("onSheetRemove", [name]);
	}
}

export function rename(view,name,newName){
	if (name == newName) return;

	//correct sheet name
	var i = 1;
	while (!newName || getSheet(view, newName)){
		newName = webix.i18n.spreadsheet.labels.sheet + i;
		i++;
	}
	newName = newName.replace(/[*?:[\]\\/]/g,"").substring(0, 31);

	var sheet = getSheet(view, name);
	var sheets = view.$$("sheets");

	sheet.name = newName;
	if(view._activeSheet == name)
		view._activeSheet = newName;

	if(sheets){
		let item = sheets.getItem(name);
		item.value = newName;
		sheets.data.changeId(name,newName);
		sheets.refresh(newName);
	}

	view.callEvent("onSheetRename", [name, newName]);
}

export function serialize(view, obj){
	getSheet(view, view._activeSheet).content = obj;
	return view._sheets;
}

export function load(view, obj){
	obj = webix.isArray(obj)?{sheets:obj}:obj;
	
	if((obj.excel || !obj.sheets) && view._activeSheet){
		//loading into active sheet
		var name = view._activeSheet;
		getSheet(view, name).content = obj;
		refresh(view, obj);
	} else {
		//creating new set of sheets
		prepare(view, obj);
	}
}

export function prepare(view, obj){
	if(!obj) obj = {data:[]}; 
	if(!obj.sheets)
		obj = newSheet(obj);
	
	var name = obj.sheets[0].name;
	view._activeSheet = "";
	view._sheets = obj.sheets;
	reset(view, obj);
	show(view, name);
}

export function newSheet(obj){
	return {
		sheets:[{
			name: webix.i18n.spreadsheet.labels.sheet + 1,
			content: obj
		}]
	};
}

export function show(view,name){
	if (name == view._activeSheet) return;

	if(view.callEvent("onBeforeSheetShow", [name])){
		if (view._activeSheet)
			getSheet(view, view._activeSheet).content = view.serialize();

		view._activeSheet = name;
		var obj = getSheet(view, name).content;
		refresh(view, obj);

		view.callEvent("onAfterSheetShow", [name]);
	}
}

export function getSheet(view, name){
	return arr.find(view._sheets, x => x.name == name);
}

export function eachSheet(view, callback){
	for (var i=0; i<view._sheets.length; i++)
		callback(view._sheets[i].name);
}

export function getActive(view){
	return view._activeSheet;
}

function refresh(view, obj){
	let [rows, cols] = arr.getDimension(obj.data, view.config.rowCount, view.config.columnCount);
	view.callEvent("onReset", []);
	if (rows != view.config.rowCount || cols != view.config.columnCount){
		view.config.rowCount = rows;
		view.config.columnCount = cols;
		view._resetTable();
	}

	view._loading_data = true;
	view.callEvent("onDataParse", [obj]);
	view._loading_data = false;
	view._table.refresh();
	if(view.config.bottombar)
		view.$$("sheets").refresh();
}

function copy(view){
	add(view, view.serialize());
}

function callAction(view, id){
	if(!view.$sheetMenu.data.getMark(id, "webix_disabled"))
		actionMap[id](view);
}

